import { useEffect, useState } from 'react';
import { SMALL_SCREEN_THRESHOLD } from '../../constants';

const useIsMobileDevice = (maxWidth: number = SMALL_SCREEN_THRESHOLD) => {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return width <= maxWidth;
};

export default useIsMobileDevice;
